import { FileService as OvermapFileService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FileService extends OvermapFileService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
